var map = {
	"./en.png": 5195,
	"./kr.png": 1741,
	"./my.png": 2108,
	"./rs.png": 8583,
	"./th.png": 4642,
	"./vn.png": 5998,
	"./zh.png": 3084,
	"./zhHant.png": 8059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8933;